// extracted by mini-css-extract-plugin
export default {"container":"Register_container__Nmi2M","loginBox":"Register_loginBox__M35QP","registerLink":"Register_registerLink__25-+q"};